import QuestionController from "../question_controller"

export default class extends QuestionController {
  static targets = ['rankInput', 'otherInput', 'otherOptionWrapper', 'otherOptionText']

  handleOtherOptionRankChange(event) {
    if (event.target.value == "") {
      this.otherOptionWrapperTarget.classList.add('disabled')
      this.otherOptionTextTarget.disabled = true
      this.otherOptionTextTarget.value = ""
    } else {
      this.otherOptionWrapperTarget.classList.remove('disabled')
      this.otherOptionTextTarget.disabled = false
    }
  }

  otherRanked() {
    return this.hasOtherInputTarget && this.otherInputTarget.value != "" ? true  : false
  }

  rankedFields() {
    return this.rankInputTargets.filter(input => input.value !="")
  }

  validateForm() {
    let valid = true

    if (this.otherRanked()) {
      valid = this.validateOther()
    }

    if (this.isRequired()) {
      valid = this.validateMinimumSelection() && valid
    }

    valid = this.validateNoMissingRanks() && valid
    return valid
  }

  validateOther() {
    this.otherInputTarget.classList.remove("error")
    this.otherOptionTextTarget.classList.remove("error")
    if (this.otherOptionTextTarget.value === "") {
      this.displayFlash("danger", "You selected \"other\" but did not include any text. Please add text or chose another option.")
      this.otherInputTarget.classList.add("error")
      this.otherOptionTextTarget.classList.add("error")
      return false
    }

    return true
  }

  validateMinimumSelection() {
    if (this.rankedFields().length == 0) {
      this.displayFlash("danger", "Please select at least one option to be ranked")
      return false
    }

    return true
  }

  validateNoMissingRanks() {
    let duplication = false
    this.rankInputTargets.forEach(input => input.classList.remove("error"))

    const ranks = this.rankedFields().map(input => input.value).sort()
    if(ranks.length == 0) {return true}
    if(ranks.length != ranks[ranks.length - 1] || new Set(ranks).size !== ranks.length){

      const rankedBuckets = new Map()
      this.rankedFields().forEach(element => {
        if(rankedBuckets.has(element.value)) {
          rankedBuckets.get(element.value).push(element)
        }else{
          rankedBuckets.set(element.value, [element])
        }
      })

      for (const bucket of rankedBuckets.values()) {

        if(bucket.length > 1) {
          duplication = true
          bucket.forEach(element => {
            element.classList.add("error")
          })
        }
      }
      if(duplication){
        this.displayFlash("danger", "You have duplicated options. Please use individual numbers for each choice.")
      }else{
        this.displayFlash("danger", "It looks like you might have missed out a few options. Please check that you have selected your choices in order.")
      }
      return false
    }
    return true
  }

  arrayHasDuplicates(array) {
    return new Set(array).size !== array.length
  }

}
